export default __webpack_public_path__ + "static/media/Ballroll_00148.25883d62.png";